// SHER-590 (render gap): the inpatient medication view remounts its fill form via
// a React `key`. The underlying redux-form (`components/general/form.jsx`) is
// `reduxForm({ form: 'form' })` with NO `enableReinitialize`, so it seeds its
// field values ONCE at mount and never re-seeds when `initData` changes. The list
// therefore only refreshes when the FillDataCollection subtree REMOUNTS — i.e.
// when this key changes.
//
// Keying on submission COUNT alone was invariant across the slim→full transition:
// the slim metadata load and the full load carry the SAME submissions, the slim
// ones just with empty `surveyRecords`. So when the real medication records arrive
// after mount (soft-navigating into the section), the count is unchanged, the form
// does not remount, and the list stays empty until a hard browser refresh (full
// remount) or a create (which changes the count). Reported by Stepping Stone
// Hospice: "click medication inpatients, nothing shows; I have to refresh on each
// patient".
export function medicationFormRemountKey(
    uuidSurvey: string,
    filteredRecords: Array<{ surveyRecords?: Array<{ value?: unknown }> } | null | undefined>,
): string {
    const records = Array.isArray(filteredRecords) ? filteredRecords : [];
    // Count the actual loaded treatment rows, not just the submissions: this is 0
    // while the store holds only slim rows (empty surveyRecords) and jumps to N the
    // moment the full records load, so the key — and therefore the form — changes
    // exactly when the content arrives.
    const treatmentCount = records.reduce((n, rec) => {
        const value = rec?.surveyRecords?.[0]?.value;
        return n + (Array.isArray(value) ? value.length : 0);
    }, 0);
    return `${uuidSurvey}-${records.length}-${treatmentCount}`;
}
